export default __webpack_public_path__ + "static/guerrilla_r1-e46983d48f5fcf7a84dc6f46888ea793.jpg";